// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import AddCompetitionExpenses from '../addCompetitionExpense';

class ViewCompetitionExpense extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id:props.id,
      competition_id:props.competition_id,
      status_types: [],
      expense_types: [],
      buddy_search_list:[],
      data_uploaded: false,
      data_error: false,
      search:true,
      addExpenseView:false,
      expense_details:[],
      billView:false,
      deleteExpense:false,
      bill_source:'',
      selected_expense_id:'',
      purposes:[],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFilebill = this.handleFilebill.bind(this);
    this.getCompetitionExpenseInputs = this.getCompetitionExpenseInputs.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.getSearchList = this.getSearchList.bind(this);
    this.setSearch = this.setSearch.bind(this);
    this.getExpenseDetail = this.getExpenseDetail.bind(this);
  }
  componentDidMount() {
    console.log(this.state);
    console.log('this is componentDidMount')
    this.getExpenseDetail();
    this.getCompetitionExpenseInputs();
  }
  getCompetitionExpenseInputs() {
        const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_competition_expense/`;
        const options = {...defaultOptions};
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({status_types: data.status_types,expense_types: data.expense_types,purposes:data.purposes}))
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
  }
  getExpenseDetail() {
        const url = `${getLocationOrigin()}/tournament/get_competition_expense/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'competition_id': this.state.competition_id
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({expense_details: data.expense_detail, search: true}))
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
    }

  getSearchList(expense_id) {
        this.setState({selected_expense_id:expense_id})
        var mobile_no = '';
        var new_selected_one =  Object.assign([], this.state.expense_details);
        for(var i = 0;i<new_selected_one.length;i++){
          if(new_selected_one[i].id == expense_id){
            mobile_no = new_selected_one[i].mobile_no
          }
        }
        const url = `${getLocationOrigin()}/eagleeye/search_buddy/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'search': mobile_no
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({buddy_search_list: data.results, search: true}))
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
    }

  setSearch(name, buddy_id, mobile_no,expense_id){
        var new_selected_one =  Object.assign([], this.state.expense_details);
        for(var i = 0;i<new_selected_one.length;i++){
          if(new_selected_one[i].id == expense_id){
            new_selected_one[i]['new_paid_by'] = buddy_id
            new_selected_one[i]['paid_by'] = [buddy_id,name]            
          }
        }
        this.setState({expense_details: new_selected_one, search: false});
    }

  postSaveExpense(data, props) {
    console.log(data);
    console.log('postSaveExpense')
    const url = `${getLocationOrigin()}/tournament/save_expense_details/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                             'id': data.id,
                             'purpose':data.purpose,
                             'item':data.item,
                             'quantity':data.quantity,
                             'size':data.size,
                             'amount':data.amount,
                             'status':data.status,
                             'expense_type':data.expense_type,
                             'new_paid_on_date':data.new_paid_on_date,
                             'new_bill':data.new_bill,
                             'new_paid_by':data.new_paid_by,
                           });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((response) =>{                      // first then()
          alert(response.message);
          this.setState({addExpenseView:false})
        })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
    
  }
  postDeleteExpense(){
    console.log('postDeleteExpense')
    const url = `${getLocationOrigin()}/tournament/delete_competition_expense/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'id': this.state.selected_expense_id
                     });
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(data => {alert(data.message)
      this.setState({deleteExpense:false})
      this.getExpenseDetail(); })
      .catch(error => {
          console.log(error);
          alert(error.message);
       });
  }

  handleChange(event,expense_id) {
    const name = event.target.name;
    console.log(this.state.expense_details)
    console.log(expense_id)
    var new_selected_one =  Object.assign([], this.state.expense_details);
    for(var i = 0;i<new_selected_one.length;i++){
      if(new_selected_one[i].id == expense_id){
        console.log('yes this is matching')
        new_selected_one[i][name] = event.target.value
        this.setState({expense_details: new_selected_one});
      }
    }
    console.log(this.state.expense_details)
  }
  handleDateChange(date,expense_id){
    var new_selected_one =  Object.assign([], this.state.expense_details);
    for(var i = 0;i<new_selected_one.length;i++){
      if(new_selected_one[i].id == expense_id){
        new_selected_one[i]['new_paid_on_date'] = date
        new_selected_one[i]['paid_on_date'] = date
        this.setState({expense_details: new_selected_one});
        console.log(this.state.expense_details)
      }
    }
  }
  handleDeleteExpense(expense_id){
    this.setState({selected_expense_id:expense_id,deleteExpense:!this.state.deleteExpense,billView:false})
  }

  handleSubmit(expense_id) {
    console.log(expense_id)
    var obj= Object.assign([], this.state.expense_details);
    var new_obj = {}
    for (var i=0;i<obj.length;i++){
        if(obj[i].id == expense_id){
          new_obj = obj[i]
          if(!new_obj['new_bill']){new_obj['new_bill'] = ''}
          if(!new_obj['new_paid_by']){new_obj['new_paid_by'] = ''}
          if(new_obj['new_paid_on_date'])
            {new_obj['new_paid_on_date'] = moment(new_obj['new_paid_on_date'])} 
          else{new_obj['new_paid_on_date'] = ''}
          this.postSaveExpense(new_obj, this.props);
        }
    }
    
    console.log('post');
    console.log(this.state);
  }
  toAddExpense(){
    this.setState({addExpenseView:!this.state.addExpenseView})
  }
  onViewBill(bill_source,expense_id){
    this.setState({billView:!this.state.billView,bill_source:bill_source,selected_expense_id:expense_id})
  }

  handleFilebill(selectorFiles: FileList){
    var new_selected_one =  Object.assign([], this.state.expense_details);
    console.log(selectorFiles);
    for (var i=0;i<new_selected_one.length;i++){
        if(new_selected_one[i].id == this.state.selected_expense_id){
          new_selected_one[i]['new_bill'] = selectorFiles[0]
          this.setState({expense_details: new_selected_one,bill_source:''});
          console.log(this.state.expense_details);
        }
    }
  }
  render() {
    const okaction = <input type="button" className="button1" value="OK" onClick={() => {this.onViewBill()}} /> ;
    const deleteAction = [
        <input type="button" className="button1" value="Delete" style={{backgroundColor:'red',marginRight:'10px'}} onClick={() => {this.postDeleteExpense()}} />,
        <input type="button" className="button1" value="Cancel" onClick={() => {this.handleDeleteExpense()}} />
      ];
    return(
      <div className="col-md-12" style={{padding:'1%'}}> 
        <div className="col-md-12" style={{display:'flex',flexDirection:'row'}} >
          <div className="col-md-6" style={{textAlign:'left',padding:'25px'}} >
            
              <Link to={"/crud/addCompetitionExpense/" + this.state.competition_id}>
                <input type="button" className="button1" value="Add Expense" />
              </Link>
          </div> 
            <div className="col-md-6" style={styles.button_view} >
            <i  style={{marginLeft:'20px'}} className="far fa fa-history" />
            </div>
        </div>
        <div className="col-md-12" style={{padding:'1%'}}>          
          { this.state.expense_details.length > 0 && 
            <div className="col-md-12" style={styles.table} >
                 <div className="col-md-12" style={styles.sub_header}> Expenses </div> 
                <table className="table_plain" >
                          <tr>
                                <th>Purpose </th>
                                <th>Item </th>
                                <th>Quantity </th>
                                <th>Amount </th>
                                <th>Status </th>
                                <th>Type </th>
                                <th>Actions </th>
                          </tr>                   
                      { this.state.expense_details.map((expense,index) =>
                      <tr key={index}>
                        <td> 
                            {this.state.purposes && this.state.purposes.map((purpose, index) => {return <div key={index}> {purpose[0] == expense.purpose && purpose[1] }</div>})}
                        </td>
                        <td>{expense.item}</td>
                        <td>{expense.quantity}</td>
                        <td>{expense.amount} </td>
                        <td>{this.state.status_types.map((x, index) => {return <div key={index}> {x[0] == expense.status && x[1] }</div>})}
                         </td>
                        <td>{this.state.expense_types.map((type, index) => {return <div key={index}> {type[0] == expense.expense_type && type[1] }</div>})}
                        </td>
                        <td style={{fontSize:'25px'}}>
                        <a href={`../../#/crud/editCompetitionExpense/${expense.id}`} title="Edit" class="x1"><i className="far fa fa-edit"  style={{marginLeft:'10%'}}></i></a>
                            <i className="far fa fa-trash" style={{fontSize:'30px',paddingLeft:'10%'}} onClick={() => this.handleDeleteExpense(expense.id)}/>          
                        
                        </td> 
                      </tr>
                      )}
                      </table>
                      {this.state.deleteExpense && 
                                    <Dialog
                                                actions={deleteAction}
                                                modal={false}
                                                open={true}
                                                autoDetectWindowHeight={true}
                                                autoScrollBodyContent={true}
                                                scroll={scroll}
                                                dividers={scroll === 'paper'}
                                              >
                                              <h2> Do You Want To delete this Expense </h2>
                                    </Dialog>
                                }
            </div>
        }
        
      </div>
      </div>
    );
  }
}

export default ViewCompetitionExpense;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/viewCompetitionExpense/index.js